import React from "react";

function Cards() {
  return (
    <div>
      {" "}
      <div className="row mb-4">
        <div className="col-md-3">
          <div className="card bg-light text-center">
            <div className="card-body" style={{ padding: "10px" }}>
              <h5 style={{ fontSize: "16px" }}>MRF Record Count</h5>
              <p className="card-text display-11">11,809M</p>
            </div>
          </div>
        </div>
        <div className="col-md-3">
          <div className="card bg-light text-center">
            <div className="card-body" style={{ padding: "10px" }}>
              <h5 style={{ fontSize: "16px" }}>Billing NPI Count</h5>
              <p className="card-text display-10">7,809M</p>
            </div>
          </div>
        </div>
        <div className="col-md-3">
          <div className="card bg-light text-center">
            <div className="card-body" style={{ padding: "10px" }}>
              <h5 style={{ fontSize: "16px" }}>Billing NPI Count</h5>
              <p className="card-text display-10">7,809M</p>
            </div>
          </div>
        </div>
        <div className="col-md-3">
          <div className="card bg-light text-center">
            <div className="card-body" style={{ padding: "10px" }}>
              <h5 style={{ fontSize: "16px" }}>Billing NPI Count</h5>
              <p className="card-text display-10">7,809M</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Cards;
